import * as o from "react";
import r from "../lib/SSRBase.es.js";
import c from "../defs/ClockCountdown.es.js";
const t = o.forwardRef((n, e) => /* @__PURE__ */ o.createElement(r, { ref: e, ...n, weights: c }));
t.displayName = "ClockCountdownIcon";
const s = t;
export {
  s as ClockCountdown,
  t as ClockCountdownIcon
};
